import { FileInput } from '@mantine/core';
import SRD_DataTable from "components/DataTable";
import { saveAs } from 'file-saver';
import { useState } from 'react';
import * as XLSX from 'xlsx';

import {
  Button,
  Center,
  Flex,
  Text
} from "@mantine/core";
import { modals } from "@mantine/modals";
//import { insertObj } from "../apis/adminSiteEditApis";

function ObjectManagement(props) {    // [오브젝트 관리 / 오브젝트 리스트 테이블 ] - [오브젝트 생성 /수정 /복사 /삭제 ]
  const {
    objectList,
    setObjectList,
    setDeleteObjectList,
    imgyeList,
    setImgyeList,
    handleObjectAddEditModalOpen,
    selectedRecords,
    setSelectedRecords,
    setDeleteImgyeList,
  } = props;

  const [uploadFile, setUploadFile] = useState(null);

  // 컴포넌트 마운트 시 objectList 출력
  // useEffect(() => {
  //   if (objectList && objectList.length > 0) {
  //     console.log('진입시 ObjectList JSON:', JSON.stringify(objectList, null, 2));
  //   }
  // }, []);

  const deleteObject = () => {      // 오브젝트 삭제
    const commonObjectIDs = selectedRecords.map((record) => record.obj_id);
    const filteredObjectList = objectList.filter(
      (object) => !commonObjectIDs.includes(object.obj_id)
    );
    const filteredImgyeList = imgyeList.filter(
      (imgye) => !commonObjectIDs.includes(imgye.obj_id)
    );
    const toBeDeleteImgyeList = imgyeList.filter(
      (imgye) => commonObjectIDs.includes(imgye.obj_id)
    );

    modals.openConfirmModal({
      title: "오브젝트 삭제",
    //  centered: true,
      zIndex: 2050,
      children: (
        <Center>
          <Text>{selectedRecords.length}개의 오브젝트를 삭제하시겠습니까?</Text>
        </Center>
      ),
      labels: { confirm: "삭제", cancel: "취소" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        setObjectList(filteredObjectList);
        setDeleteObjectList((prev) => [...prev, ...selectedRecords]);
        setImgyeList(filteredImgyeList);
        setDeleteImgyeList((prev) => [...prev, ...toBeDeleteImgyeList]);
        setSelectedRecords([]);
      },
    });
  };

  const copyObject = () => {      //오브젝트 복사

    const editModeFlag = false;

    const _ = require("lodash");
    const commonObjectIDs = selectedRecords.map((record) => record.obj_id);
    const copyObjectList = _.cloneDeep(selectedRecords);
    const selectImgyeList = imgyeList.filter(
      (imgye) => commonObjectIDs.includes(imgye.obj_id)
    );
    const copyImgyeList = _.cloneDeep(selectImgyeList);

    let seq = 0 ;
    let minLeft = 1600;
    let maxLeft = 0;

    copyObjectList.forEach((item) =>{
      if (item.obj_seq > seq) {
        seq = item.obj_seq;
      }
      if (item.left > maxLeft) {
        maxLeft = item.left;
      }
      if (item.left < minLeft) {
        minLeft = item.left;
      }
    });

    let copyLoc = 0;
    let leftWidth = maxLeft - minLeft;
    if ( (maxLeft <= 800) && (leftWidth <= 400) ){
      copyLoc = 1;
    } else if ( (maxLeft <= 800) && (leftWidth > 400) && (leftWidth <= 800)) {
      copyLoc = 2;
    } else if ( (800 < maxLeft) && (maxLeft <= 1200) && (leftWidth <= 400) ) {
      copyLoc = 1;
    } else if ( (800 <= maxLeft) && (maxLeft <= 1200) && (leftWidth < 800) && (leftWidth > 400) ) {
      copyLoc = -2;
    } else {
      copyLoc = 0;
    }

    copyObjectList.forEach((item) =>{
      copyImgyeList.forEach((imgye) => {
        if (imgye.obj_id === item.obj_id) {
          imgye.obj_id = `OBJ-${item.obj_id}`;
          imgye.imgye_id =  `OBJ-${item.obj_id}` ;
        }
        if ( !editModeFlag ){
          imgye.bsd_ctrl_id = null;
          imgye.bsd_sttus_id = null;
        }
        imgye.chnnl_sttus_value = null;
      });

      item.obj_seq = ++seq;
      item.obj_id = `OBJ-${item.obj_id}`;
      item.user_id = "";
    //  item.top = item.top + 5;
      let copyOffset = copyLoc * 400;
      if (copyLoc === 0 ){
        copyOffset = copyOffset + 100;
      }
      item.left =  item.left + copyOffset ;

      if ( !editModeFlag ){
        item.bsd_id = "";
        item.bsd_ctrl_id = null;
        item.bsd_sttus_id = null;
//        item.cntl_yn = "N";
      //    item.sw_cs = "N";
      }
      item.bsd_ctrl_value = null;
      item.chnnl_sttus_value = null;
      item.chnnl_ctrl_value = null;
    });

    modals.openConfirmModal({
      title: "오브젝트 복사",
    //  centered: true,
      zIndex: 2050,
      children: (
          <Center>
            <Text>{selectedRecords.length}개의 오브젝트를 복사하시겠습니까?"</Text>
          </Center>
      ),
      labels: { confirm: "복사", cancel: "취소" },
      confirmProps: { color: "blue" },
      onConfirm: () => {
        setObjectList((prev) => [...prev, ...copyObjectList]);
        setImgyeList((prev) => [...prev, ...copyImgyeList]);
        setSelectedRecords([]);
        }
      });
  };

  const handleExcelUpload = () => {
    // 업로드 전 현재 objectList 출력
    console.log('Upload 전 ObjectList:', JSON.stringify(objectList, null, 2));

    modals.openConfirmModal({
      title: "엑셀 업로드",
      size: "md",
      zIndex: 2050,
      children: (
        <Center style={{ flexDirection: 'column', gap: '20px' }}>
          <Text>엑셀 파일의 데이터로 오브젝트 목록을 업데이트하시겠습니까?</Text>
          <FileInput
            placeholder="엑셀 파일 선택"
            accept=".xlsx,.xls"
            style={{ width: '100%' }}
            onChange={setUploadFile}
          />
        </Center>
      ),
      labels: { confirm: "확인", cancel: "취소" },
      onConfirm: () => {
        if (!uploadFile) {
          alert('파일을 선택해주세요.');
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const excelData = XLSX.utils.sheet_to_json(worksheet);

          const newObjectList = excelData.map((row, index) => {
            return {
              // 기본 필드들
              obj_id: row.obj_id || `OBJ-${index + 1}`,
              obj_nm: row.obj_nm,
              type: row.type || '1',
              obj_seq: row.obj_seq || (index + 1),
              bsd_id: row.bsd_id,

              // 위치 및 크기 관련 필드
              left: row.left !== undefined ? row.left : 0,
              top: row.top !== undefined ? row.top : 0,
              width: row.width !== undefined ? row.width : 30,
              height: row.height !== undefined ? row.height : 30,

              // 표시 관련 필드
              view_yn: row.view_yn || 'Y',
              t_yn: row.t_yn || 'N',
              t_cont: row.t_cont,
              t_sort: row.t_sort || 'Center',
              t_font_s: row.t_font_s !== undefined ? row.t_font_s : 12,
              t_font_c: row.t_font_c || '#000000',
              t_cont_bg: row.t_cont_bg,

              // URL 관련 필드
              img_url: row.img_url,
              cctv_url: row.cctv_url,

              // 사용자 및 장치 관련 필드
              user_id: row.user_id,
              bsd_ctrl_id: row.bsd_ctrl_id !== undefined ? row.bsd_ctrl_id : null,
              bsd_sttus_id: row.bsd_sttus_id !== undefined ? row.bsd_sttus_id : null,

              // 채널 상태 및 제어 관련 필드
              chnnl_sttus_value: row.chnnl_sttus_value !== undefined ? row.chnnl_sttus_value : null,
              chnnl_ctrl_value: row.chnnl_ctrl_value !== undefined ? row.chnnl_ctrl_value : null,
              chnnl_set_value: row.chnnl_set_value !== undefined ? row.chnnl_set_value : null,

              // 제어 관련 필드
              sw_cs: row.sw_cs || 'N',

              // 기타 필드들이 있다면 그대로 유지
              ...row
            };
          });

          // 오브젝트 리스트 업데이트 후 새로운 objectList 출력
          setObjectList(newObjectList);
          console.log('Upload 후 ObjectList:', JSON.stringify(newObjectList, null, 2));

          // 기존 imgye 리스트 초기화
          setImgyeList([]);

          // 선택된 레코드 초기화
          setSelectedRecords([]);

          alert('엑셀 파일이 성공적으로 업로드되었습니다.');
          setUploadFile(null); // 파일 선택 상태 초기화
        };

        reader.readAsArrayBuffer(uploadFile);
      },
    });
  };

  const handleExcelDownload = () => {
    // 다운로드 시 현재 objectList 출력
    console.log('Download 시 ObjectList:', JSON.stringify(objectList, null, 2));

    // objectList의 모든 필드를 그대로 엑셀 데이터로 변환
    const excelData = objectList.map(obj => {
      // 각 객체의 모든 필드를 복사
      return {
        ...obj,
        // null 값은 빈 문자열로 변환
        obj_id: obj.obj_id,
        obj_nm: obj.obj_nm,
        type: obj.type,
        obj_seq: obj.obj_seq,
        bsd_id: obj.bsd_id,
        left: obj.left || 0,
        top: obj.top || 0,
        width: obj.width || 30,
        height: obj.height || 30,
        view_yn: obj.view_yn || 'Y',
        t_yn: obj.t_yn || 'N',
        t_cont: obj.t_cont,
        t_sort: obj.t_sort || 'Center',
        t_font_s: obj.t_font_s || 12,
        t_font_c: obj.t_font_c || '#000000',
        t_cont_bg: obj.t_cont_bg,
        img_url: obj.img_url,
        cctv_url: obj.cctv_url,
        user_id: obj.user_id,
        bsd_ctrl_id: obj.bsd_ctrl_id,
        bsd_sttus_id: obj.bsd_sttus_id,
        chnnl_sttus_value: obj.chnnl_sttus_value,
        chnnl_ctrl_value: obj.chnnl_ctrl_value,
        sw_cs: obj.sw_cs
      };
    });

    // 변환된 엑셀 데이터 출력
    console.log('Download용 변환된 ExcelData:', JSON.stringify(excelData, null, 2));

    // 워크북 생성
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(excelData);
    XLSX.utils.book_append_sheet(wb, ws, "오브젝트 목록");

    // 엑셀 파일 생성 및 다운로드
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

    // ArrayBuffer 생성
    const buf = new ArrayBuffer(wbout.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < wbout.length; i++) {
      view[i] = wbout.charCodeAt(i) & 0xFF;
    }

    // Blob 생성 및 다운로드
    const blob = new Blob([buf], { type: 'application/octet-stream' });
    saveAs(blob, 'srd_site_data.xlsx');
  };

  return (
    <>
    <Flex mt={10} gap={10} direction={"column"} className="object-management">
      <Flex justify="space-between" align="center">
        <Text fw={500}>오브젝트</Text>
        <Flex gap={10} align="center">
          <Button
            variant="outline"
            onClick={handleExcelUpload}
          >
            엑셀 업로드
          </Button>
          <Button
            variant="outline"
            onClick={handleExcelDownload}
          >
            엑셀 다운로드
          </Button>
        </Flex>
      </Flex>
      <div style={{ width: "750px", height: "700px"}}>
        <SRD_DataTable
          data={objectList}
          columns={objectColumns}
          searchBar
          idAccessor="obj_id"
          selectedRecords={selectedRecords}
          setSelectedRecords={setSelectedRecords}
        />
      </div>
      <div style={{ width: "750px", height: "80px"}}>
        <Flex mt={10} gap={10} justify={"flex-end"} >
          <Button onClick={handleObjectAddEditModalOpen}>오브젝트 생성</Button>
          <Button
            variant="outline"
            disabled={selectedRecords.length !== 1}
            onClick={() =>
              handleObjectAddEditModalOpen(selectedRecords[0].obj_id)
            }
          >
            오브젝트 수정
          </Button>
          <Button           // add by bjkim6114
            variant="outline"
            onClick={copyObject}
            disabled={selectedRecords.length === 0}
          >
            오브젝트 복사
          </Button>
          <Button
            color={"red"}
            onClick={deleteObject}
            disabled={selectedRecords.length === 0}
          >
            오브젝트 삭제
          </Button>
          </Flex>
        </div>
      </Flex>
    </>
  );
}

export default ObjectManagement;

const objectColumns = [       // 오브젝트 리스트 테이블블
  {
    accessor: "index",
    title: "번호",
    textAlignment: "center",
    width: 30,
    render: (record, index) => index + 1,
  },
  {
    accessor: "obj_id",
    title: "오브젝트 ID",
    textAlignment: "center",
    width: 90,
  },
  {
    accessor: "type",
    title: "유형",
    textAlignment: "center",
    width: 60,

    render: (record) => {
      if (record.type === "1") return "관제";
      else if (record.type === "2") return "CCTV";
      else if (record.type === "3") return "날씨";
      else if (record.type === "4") return "통신";      //add by  bjkim6114
    },
  },
  {
    accessor: "obj_nm",
    title: "오브젝트명",
    textAlignment: "center",
    width: 220,
  },
  {
    accessor: "obj_seq",
    title: "순서",
    textAlignment: "center",
    width: 60,
  },
  {
    accessor: "bsd_id",
    title: "장치 ID",
    textAlignment: "center",
    width: 60,
    render: (record) => record.bsd_id && record.bsd_id,
  },
  {
    accessor: "device_status",
    title: "장치",
    textAlignment: "center",
    width: 40,
    render: (record) => record.bsd_id && "O",
  },
];
